"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M6.141 17.793c-.205-.453-.18-.927.033-1.38.21-.445.546-.77.99-.958l.01-.004.01-.004a1.61 1.61 0 0 1 1.197.037c.401.165.73.46.99.853l.012.017.01.017c.305.554.687.94 1.143 1.184.478.255.99.383 1.544.383.84 0 1.451-.197 1.882-.54.417-.332.625-.768.625-1.357 0-.68-.23-1.194-.684-1.585-.489-.422-1.449-.883-2.952-1.357-1.464-.452-2.62-1.138-3.425-2.081C6.71 10.065 6.31 8.9 6.31 7.554a4.98 4.98 0 0 1 1.099-3.17c.687-.868 1.687-1.412 2.949-1.668V1.554c0-.437.137-.831.443-1.13C11.1.13 11.48 0 11.898 0c.407 0 .774.137 1.068.424.306.299.443.693.443 1.13v1.182c.614.16 1.197.397 1.746.712a4.988 4.988 0 0 1 1.678 1.572l.004.006.004.007c.26.418.303.883.133 1.348-.167.46-.493.788-.938.98a1.573 1.573 0 0 1-1.157.065c-.386-.12-.747-.356-1.085-.681l-.012-.011-.01-.013a2.146 2.146 0 0 0-.802-.551 2.97 2.97 0 0 0-1.132-.201c-.774 0-1.297.161-1.631.42-.318.245-.484.582-.484 1.072 0 .53.187.958.575 1.316.187.173.529.383 1.064.623a19.18 19.18 0 0 0 2.058.755l.01.003c1.461.494 2.604 1.201 3.389 2.145.798.96 1.181 2.178 1.181 3.614 0 1.465-.418 2.695-1.286 3.646-.793.87-1.91 1.431-3.305 1.718v1.165c0 .437-.137.831-.444 1.13a1.48 1.48 0 0 1-1.067.424c-.418 0-.798-.131-1.097-.424-.306-.299-.443-.693-.443-1.13v-1.203c-.947-.217-1.765-.598-2.442-1.153a6.544 6.544 0 0 1-1.771-2.29l-.004-.007Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};